var exports = {
  "o": "x31de4314--f7d306--underground-icon",
  "F": "x31de4314--f7d306--underground-icon--regions",
};

module.exports = exports;
